import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DataTable from "../components/DataTable";

const ListarEProductiva = () => {
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);
  const navigate = useNavigate();

  const toDate = (d) => {
    if (!d) return "";
    try {
      return new Date(d).toLocaleDateString();
    } catch {
      return "";
    }
  };

  const fullName = (o, pfx) => {
    if (!o) return "—";
    const nombre = [
      o[`${pfx}1`],
      o[`${pfx}2`],
      o[`apellido1${pfx.slice(0, 1).toUpperCase() + pfx.slice(1)}`],
      o[`apellido2${pfx.slice(0, 1).toUpperCase() + pfx.slice(1)}`],
    ]
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();
    return nombre || o[`nombre${pfx[0].toUpperCase() + pfx.slice(1)}`] || o.nombreCompleto || o.nombre || "—";
  };

  const getData = useCallback(async () => {
    setCargando(true);
    try {
      const { data } = await axios.get("/api/etapapractica/listall");

      const etapasConFunciones = (data.etapas || []).map((ep) => {
        const aprendizId = ep?.aprendizObjectId?._id;
        const matriculaId = ep?.matriculaObjectId?._id;

        const nombreAprendiz = [
          ep?.aprendizObjectId?.nombre1Aprendiz,
          ep?.aprendizObjectId?.apellido1Aprendiz,
          ep?.aprendizObjectId?.apellido2Aprendiz,
        ].filter(Boolean).join(" ").trim();

        const nombreInstructor = [
          ep?.instructorObjectId?.nombre1Instructor,
          ep?.instructorObjectId?.nombre2Instructor,
          ep?.instructorObjectId?.apellido1Instructor,
          ep?.instructorObjectId?.apellido2Instructor,
        ].filter(Boolean).join(" ").trim();

        const nombreJefe = [
          ep?.jefeObjectId?.nombre1Jefe,
          ep?.jefeObjectId?.apellido1Jefe,
        ].filter(Boolean).join(" ").trim();

        return {
          ...ep,
          documentoAprendiz: ep?.aprendizObjectId?.documentoAprendiz ?? "—",
          nombreAprendiz: nombreAprendiz || "—",
          codMatricula: ep?.matriculaObjectId?.codMatricula ?? "—",
          ente: ep?.enteObjectId?.nombreEnteconformador ?? "—",
          instructor: nombreInstructor || "—",
          jefe: nombreJefe || "—",
          fechaInicio: toDate(ep?.fechaInicioEtapaPractica),
          fechaFin: toDate(ep?.fechaFinEtapaPractica),
          funciones: (
            <div className="d-flex gap-2">
              {/* Ver Aprendiz */}
              <button
                className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => aprendizId && navigate(`/aprendiz/${aprendizId}`)}
                title="Ver Aprendiz"
              >
                <i className="fa-solid fa-user" />
              </button>

              {/* Editar Etapa */}
              <button
                className="btn btn-warning btn-sm d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/etapaproductiva/registro/editar/${ep._id}`)}
                title="Editar Etapa Productiva"
              >
                <i className="fa-solid fa-edit" />
              </button>

              {/* 📋 Ver Seguimiento de la etapa */}
              <button
                className="btn btn-warning btn-sm d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() =>
                  navigate(`/etapaproductiva/seguimiento/${ep._id}/${aprendizId}/${matriculaId}`)
                }
                title="Ver Seguimiento"
              >
                <i className="fa-solid fa-clipboard-list" />
              </button>


              {/* 🆕 Ver Bitácoras de la etapa */}
              <button
                className="btn btn-info btn-sm d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/etapaproductiva/bitacoras/${ep._id}/${aprendizId}/${matriculaId}`)}
                title="Ver Bitácoras"
              >
                <i className="fa-solid fa-book" />
              </button>

              {/* Ver Matriculados */}
              {matriculaId && (
                <button
                  className="btn btn-secondary btn-sm d-flex align-items-center justify-content-center"
                  style={{ width: 30, height: 30, padding: 0 }}
                  onClick={() => navigate(`/matricula/listarmatriculados/${matriculaId}`)}
                  title="Ver Matriculados"
                >
                  <i className="fa-solid fa-users" />
                </button>
              )}

              {/* Eliminar Etapa */}
              <button
                className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => deleteEPractica(ep._id)}
                title="Eliminar Etapa Productiva"
              >
                <i className="fa-solid fa-trash" />
              </button>
            </div>
          ),
        };
      });

      setItems(etapasConFunciones);
    } catch (error) {
      console.error("Error al cargar las etapas productivas:", error.message);
      Swal.fire("Error", "No se pudieron cargar las etapas productivas.", "error");
    } finally {
      setCargando(false);
    }
  }, [navigate]);

  const deleteEPractica = useCallback(
    async (id) => {
      try {
        const res = await Swal.fire({
          title: "¿Está seguro?",
          text: "¡No podrá revertir este proceso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        });
        if (!res.isConfirmed) return;

        const { data } = await axios.delete(`/api/etapapractica/delete/${id}`);
        await Swal.fire({
          icon: "success",
          title: data?.message || "Eliminado correctamente",
          showConfirmButton: false,
          timer: 1500,
        });
        getData();
      } catch (err) {
        console.error("Error al eliminar etapa:", err?.message);
        Swal.fire("Error", "No se pudo eliminar la etapa.", "error");
      }
    },
    [getData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      { Header: "Documento", accessor: "documentoAprendiz" },
      { Header: "Aprendiz", accessor: "nombreAprendiz" },
      { Header: "Matrícula", accessor: "codMatricula" },
      { Header: "Alternativa", accessor: "alternativaEtapaPractica" },
      { Header: "Ente", accessor: "ente" },
      { Header: "Instructor", accessor: "instructor" },
      { Header: "Jefe", accessor: "jefe" },
      { Header: "Inicio", accessor: "fechaInicio" },
      { Header: "Fin", accessor: "fechaFin" },
      { accessor: "funciones" },
    ],
    []
  );

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1 className="mb-3 px-3">Listado de Etapas Productivas</h1>
      {cargando ? (
        <p className="px-3">Cargando Etapas Productivas...</p>
      ) : Array.isArray(items) && items.length > 0 ? (
        <DataTable columns={columns} data={items} />
      ) : (
        <p className="px-3">No hay registros.</p>
      )}
    </div>
  );
};

export default ListarEProductiva;
